import { render, staticRenderFns } from "./StudentCard.vue?vue&type=template&id=9fe82cb2"
import script from "./StudentCard.vue?vue&type=script&lang=js"
export * from "./StudentCard.vue?vue&type=script&lang=js"
import style0 from "./StudentCard.vue?vue&type=style&index=0&id=9fe82cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports